export default __webpack_public_path__ + "static/media/bulk.a635fe17.png";